import { isValueEmpty } from './is-value-empty'

export type EmptyOrDefaultInput = string | number | null | undefined

export const emptyDefault = (value: EmptyOrDefaultInput, substitute: string | number = '-') => {
  return !isValueEmpty(value) ? value?.toString() : substitute
}
